var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pa-0",attrs:{"id":"home"}},[_c('hero'),_c('what'),_c('why'),_c('who'),_c('tech'),_c('contact'),_c('google-map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }